import axios from 'axios'

const axiosCustom = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    responseType: 'json',
    timeout: process.env.REACT_APP_REQUEST_TIMEOUT, // default is `0` (no timeout)
    headers: {
        'Content-Type': 'application/json',
    },
})

axiosCustom.interceptors.response.use(
    response => {
        return response
    },
    error => {
        const errormsg = error.response
            ? {
                  title: error.response.data.error,
                  message: error.response.data.message,
              }
            : {title: 'Error', message: error.message}
        return Promise.reject(errormsg)
    }
)

export default axiosCustom
